import React from 'react';
import { TranslationUtils } from '../../utils';
import { Button } from '../Button/Button';
import { ReceiptTotalTitle } from '../Receipt/ReceiptTotalTitle';
import { useIntl } from 'react-intl';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';

interface BillingInformationProps {
    preview: TripAdjustmentResponse;
    onSubmit?: () => Promise<any>;
    isLoading: boolean;
}

export const BillingInformation: React.FC<BillingInformationProps> = (props) => {
    const { preview, onSubmit, isLoading } = props;
    const { detail } = preview;
    const intl = useIntl();

    return (
        <>
            <br />
            <span className={'title-reservation-medium'}>{TranslationUtils.get('payment_form_billing_information')}</span>
            <p>{TranslationUtils.get('billing_information_note')}</p>
            <hr />
            <ReceiptTotalTitle
                summary={{
                    total: detail!.total,
                    currency: detail!.currency,
                }}
                convertedSummary={detail!.converted ? { total: detail!.converted.total, currency: detail!.converted.currency } : undefined}
                locale={intl.locale}
            />
            <p>{detail!.refund && detail!.refund.message}</p>
            <br />
            <Button
                className="btn-modify-guests-confirm mt-3"
                id="button-confirm-adjustment"
                // @ts-ignore
                onClick={onSubmit}
                isLoading={isLoading}
                label={TranslationUtils.get('confirm')}
                variant="primary"
                block
                disabled={isLoading}
            />
        </>
    );
};
